<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'mrp-list'"
    :setLoading="setLoading"
    :loadDataGrid="loaded"
    v-if="loaded"
    ref="transactionList"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import TransactionListTemplate from "../../../templates/transaction-list";
import { FeatureStorage } from "../../../_services/storage";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { mapGetters } from "vuex";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
    };
  },
  created() {
    this.loaded = true;
  },
  computed: {
    setScreenConfig() {
      return {
        title: "MRP",
        ScreenName: "MRP - All",
        selectedIndex: 0,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "MRPList",
              // serverPaging: true,
              allowGrouping: false,
              // select: [
              //   "Code",
              //   "Status",
              //   "DateIn",
              //   "CreatedBy",
              //   "LineInfo",
              //   "FriendlyStatus",
              //   "Status",
              //   "BranchCodeList",
              //   "DateCreated",
              //   "ItemCodeList",
              //   "AdjustmentTotal",
              //   // "Product",
              // ],
            },
            // rowSelect: {
            //   view: this,
            //   page: "stock-adjustment",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No MRP Found",
                message: "Get Started, Add New MRP",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/mrp/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission("MRP", "create"),
              },
            ],
          },
          columns: [
            {
              screenField: "MRPRun",
              label: "Run",
              filterIndex: 0,
              type: "Integer",
              allowHiding: false,
              sortIndex: 0,
              sortOrder: "desc",
              width: ColumnWidth.RUNNumber.width,
              forceWidth: true,
            },
            {
              screenField: "DateIn",
              dataField: "EndDate",
              label: "End Date",
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "Narration",
              filterIndex: 1,
              type: "Text",
              textOperators: true,
              customizeText: (e) => {
                if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
                else return "";
              },
              encodeHtml: false,
            },
            {
              cellTemplate: "Status",
              dataField: "Status",
              width: ColumnWidth.Status.width,
              minWidth: ColumnWidth.Status.minWidth,
              customBackGroundColor: (data) => {
                if (data) {
                  if (data.Status === "Generated") return "#4caf50";
                  else if (data.Status === "Generating...") return "#ff9800";
                  else if (data.Status === "Failed") return "#f44336";
                  return undefined;
                } else return undefined;
              },
            },
            {
              screenField: "DateCreated",
              dataField: "DateCreated",
              filterIndex: 2,
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "RequiredDate",
              dataField: "RetainDate",
              label: "Retain Date",
              visible: false,
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "CreatedBy",
              filterIndex: 3,
              width: ColumnWidth.CreatedBy.width,
              minWidth: ColumnWidth.CreatedBy.minWidth,
            },
          ],
        },
      };
    },
    ...mapGetters("notification", ["notificationId", "getNotificationPayload"]),
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "GridRecordEmail" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordPrint" &&
        (e.data.Status === "Generated" || e.data.Status === "Failed")
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "mrp",
          mode: "review",
          idProperty: "MRPRun",
        });
      }
    },
    refreshGridData() {
      if (
        this.$refs.transactionList &&
        this.$refs.transactionList.$refs.transactionListGrid
      ) {
        const gridInstance =
          this.$refs.transactionList.$refs.transactionListGrid;
        gridInstance.gridRefresh();
      }
    },
  },
  watch: {
    notificationId() {
      if (
        this.getNotificationPayload &&
        this.getNotificationPayload.messageType === "MRPGenerationCompleted"
      ) {
        this.refreshGridData();
      }
    },
  },
};
</script>
